/**
 * FAQ Accordion Section
 * Vanilla JS, no dependencies. Supports multiple instances on the same
 * page (e.g. theme editor re-renders) and both single-open and
 * multiple-open accordion behavior, controlled via the customizer.
 */
(function () {
    "use strict";

    function initFaqAccordion(root) {
        if (!root || root.dataset.faqInitialized === "true") return;
        root.dataset.faqInitialized = "true";

        var allowMultiple = root.dataset.allowMultiple === "true";
        var items = root.querySelectorAll("[data-faq-item]");

        items.forEach(function (item) {
            var trigger = item.querySelector("[data-faq-trigger]");
            if (!trigger) return;

            trigger.addEventListener("click", function () {
                var isOpen = item.getAttribute("data-open") === "true";

                if (!allowMultiple) {
                    items.forEach(function (otherItem) {
                        if (otherItem !== item) {
                            closeItem(otherItem);
                        }
                    });
                }

                if (isOpen) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            });
        });

        function openItem(item) {
            var trigger = item.querySelector("[data-faq-trigger]");
            item.setAttribute("data-open", "true");
            if (trigger) trigger.setAttribute("aria-expanded", "true");
        }

        function closeItem(item) {
            var trigger = item.querySelector("[data-faq-trigger]");
            item.setAttribute("data-open", "false");
            if (trigger) trigger.setAttribute("aria-expanded", "false");
        }
    }

    function initAll() {
        document.querySelectorAll("[data-faq-section]").forEach(initFaqAccordion);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
    } else {
        initAll();
    }

    // Re-init when a section is loaded/re-rendered inside the Shopify
    // theme editor so the accordion keeps working after edits.
    document.addEventListener("shopify:section:load", function (event) {
        var section = event.target.querySelector("[data-faq-section]");
        if (section) {
            section.dataset.faqInitialized = "false";
            initFaqAccordion(section);
        }
    });
})();